export default {
  standings: {
    title: "Classements",
    empty: {
      unavailable: "Les classements ne sont pas disponibles pour le moment.",
    },
    labels: {
      ranking: "#",
      team: "Équipe",
    },
    columns: {
      GP: "MJ",
      W: "V",
      L: "D",
      T: "N",
      OTL: "DP",
      PTS: "PTS",
      PCT: "PCT",
      D: "N",
    },
    picker: {
      conference: "Conférence",
      division: "Division",
      overall: "Général",
    },
    sections: {
      conference: "Conférence",
      division: "Division",
      overall: "Général",
    },
  },
};
